export default {
    aboutReghub: '关于锐合',
    companyIntroduce: '公司简介',
    watchTele: '何为“监管科技”',
    honorsAndQualifications: '荣誉资质',
    companyIntroduceInfor1: '锐合结合国际领先的监管理念，集多年专业化合规和风控经验，运用大数据和人工智能等创新技术，为银行及非银类金融机构提供智慧风控与合规管理及与之相关的系统化解决方案。',
    companyBriefIntroduction: {
        title1: '锐合团队',
        content1: '锐合的核心和资深顾问团队来自全球各地大型金融机构、知名风险与合规咨询公司、新兴金融科技公司、高新技术企业等。我们对监管要求和金融业的最佳实践有着深刻的认识和见解，可以多层次多视角协助客户设计、开发和执行合规与风险管理数据、系统与技术解决方案。',
        title2: '锐合咨询服务',
        content2: '我们的咨询服务覆盖中国大陆、香港、澳门、台湾地区的金融机构及其海外分支机构，为他们提供战略、运营、合规、风险管理咨询服务及与之相关的数据和产品解决方案，支持金融机构应对复杂和敏感的挑战，特别是在合规、风险和监管的交叉领域。',
        title3: '锐合产品和技术',
        content3: '我们的产品和技术解决方案覆盖风险评估、风险计量和流程优化与自动化等方面。我们充分运用机器学习、人工智能等方法，在风险建模、合规管理、数据分析等领域帮助金融机构更好地管理风险，提高效率。',
        title4: '锐合客户',
        content4: '我们的客户分布在中国和香港地区，有五大国有银行、大型跨国中资证券期货业集团、大型股份制银行、城市商业银行、持牌非银支付机构、持牌人寿保险公司。',
    },
    regulatoryTechContent: '监管科技主要有Regulation（监管、合规）和Technology（技术）两个英文单词结合而成，即RegTech，是指将科技创新技术运用于金融合规和监管之中，协助金融机构优化传统的合规与风险管理框架模式，协助监管机构提升监管手段、降低监管成本。',
    regulatoryTechContentList: {
        title1: '数字智能化',
        title2: '快速敏捷性',
        title3: '实时监控性',
        content1: '实现报告和合规流程的数字化、智能化管理，增强金融监管信息的实时性、准确性、可追溯性和不可篡改性。',
        content2: '提高快速部署和应用能力，力图产生最小的外部干扰，缓解监管时滞性，提升监管穿透性，增强监管统一性。',
        content3: '自动、实时生成所需分析报告和方案，提升金融机构合规工作效率与效用，用最小的成本满足监管和合规管理的要求。',
    },
    honorContent1: '作为一家科技创新企业，我们帮助金融机构实现技术转型和持续创新，在确保金融机构满足监管要求、合规合法经营的同时，提升金融机构自主开发能力，实现金融机构国产替代的愿景目标，同时提高合规效率，降低合规与管理成本。',
    honorContent2: '锐合凭借行业领先的咨询服务经验、结合前沿的技术力量开发一系列服务于合规与风险管理领域的工具，进而打造了锐合完整的系统和工具生态体系，强化科技对项目的赋能。',
    certificate: {
        content1: '锐合于2020年获得中关村高新技术企业证书',
        content2: '锐合于2021年获得国家高新技术企业证书',
        content3: '锐合在风险合规领域已经获得14项软件著作权证书',
    }
}